/**
 * 
 * @author 
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

 import ServicePath from "@/core/ServicePath";
 import {
     MainRequest
 } from "@/core/request";
 
 export default class SpecialityRequest extends MainRequest {
 
     static addSpeciality(data) {
         return this.postSEC(ServicePath.SPECIALITY_ADD, data)
     }
 
     static allSpeciality() {
         return this.getSEC(ServicePath.SPECIALITY_LIST_ALL)
     }
 
     static updateSpeciality(data) {
         return this.postSEC(ServicePath.SPECIALITY_UPDATE, data)
     }
     
     static deleteSpeciality(data) {
         return this.postSEC(ServicePath.SPECIALITY_DELETE, data)
     }
     
     static listStatusBySpecialty(data) {
         return this.postSEC(ServicePath.SPECIALITY_LIST_STATUS, data)
     }
 
 }
 